export default __webpack_public_path__ + "static/media/video3.1ab63b2c.mp4";